import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchProperties, insertProperty} from "./properties.api";
import {PropertyState} from "./properties.entity";
import {Property} from "@/models/properties.model.ts";
import {setPropertyImage} from "@/app/pmc/properties-detail/properties-detail.api.ts";

export const getProperties = createAsyncThunk("properties/get", fetchProperties);

const initialState: PropertyState = {
  list: [],
  loading: false,
  total: 0,
  filters: {
    type: "",
    structure: "",
    class: "",
    sortBy: "created_at",
    page: 1,
    pageSize: 9,
    sortDirection: "desc",
  },
};

export const createProperty = createAsyncThunk(
    "properties/create",
    async (values: Partial<Property>) => {
      const {image, ...rest} = values;
      const property = await insertProperty(rest);

      if (image instanceof File) return await setPropertyImage(property.id, image);

      return property;
    }
);

const propertySlice = createSlice({
  name: "properties",
  initialState,
  reducers: {
    filterByType: (state, action) => {
      state.filters.type = action.payload;
    },
    filterByStructure: (state, action) => {
      state.filters.structure = action.payload;
    },
    filterByClass: (state, action) => {
      state.filters.class = action.payload;
    },
    resetFilters: (state) => {
      state.filters.type = "";
      state.filters.structure = "";
      state.filters.class = "";
    },

    setPage: (state, action) => {
      state.filters.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.filters.pageSize = action.payload;
    },
    setSort: (state, action) => {
      state.filters.sortBy = action.payload.sortBy;
      state.filters.sortDirection = action.payload.sortDirection;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProperties.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProperties.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.total = action.payload.count;
        state.loading = false;
      }).addCase(createProperty.pending, (state) => {
        state.loading = true;
      }).addCase(createProperty.fulfilled, (state) => {
        state.loading = false;
      });
  },
});

export const { filterByType, filterByStructure, filterByClass, setPage, setPageSize, setSort, resetFilters } =
  propertySlice.actions;

export default propertySlice.reducer;
